// extracted by mini-css-extract-plugin
module.exports = {"alert":"AppsDrawer_alert__1rfF0","apps-drawer":"AppsDrawer_apps-drawer__3uLzT"};